var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_5027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0449 49.5898C61.7169 50.1818 60.2769 49.6158 58.9849 47.6758L49.7969 34.9638L48.4689 33.2038L37.7389 47.7178C36.5129 49.4638 35.2269 50.2238 32.9389 49.6058L46.6789 31.1618L33.8869 14.5018C36.0869 14.0738 37.6069 14.2918 38.9569 16.2618L48.4869 29.1318L58.0869 16.3318C59.3169 14.5858 60.6389 13.9218 62.8469 14.5658L57.8869 21.1418L51.1669 29.8918C50.3669 30.8918 50.4769 31.5758 51.2129 32.5418L64.0449 49.5898ZM0.0609219 30.8538L1.18492 25.3258C4.24492 14.3858 16.7849 9.83977 25.4329 16.5998C30.4869 20.5758 31.7429 26.1998 31.4929 32.4998H3.00492C2.57692 43.8398 10.7389 50.6838 21.1449 47.1918C24.7949 45.9658 26.9449 43.1078 28.0209 39.5318C28.5669 37.7398 29.4709 37.4598 31.1549 37.9718C30.2949 42.4438 28.3549 46.1798 24.2549 48.5178C18.1289 52.0178 9.38492 50.8858 4.78492 46.0218C2.04492 43.1998 0.912922 39.6238 0.404922 35.7998C0.324922 35.1678 0.164922 34.5658 0.0449219 33.9598C0.0555885 32.9251 0.0609219 31.8904 0.0609219 30.8558V30.8538ZM3.05692 30.0938H28.8009C28.6329 21.8938 23.5269 16.0698 16.5489 16.0198C8.88892 15.9598 3.38892 21.6458 3.05692 30.0938Z",
    fill: "#F9FAFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_5027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.0449219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpress);
export default __webpack_public_path__ + "static/media/icon-express.80951a1772dfdc858f8a83101b2e818c.svg";
export { ForwardRef as ReactComponent };